<template>
  <v-card>
    <template>
      <v-card-title primary-title>
        <div>
          <div class="headline secondary--text">{{ $t('company.participants.list.title') }}</div>
          <span class="body-1 greyDarken1--text">{{ $t('company.participants.list.subtitle') }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="exportAllConsumersReport()" color="primary">
          <v-icon small class="pr-1">$vuetify.icons.rms_media_download</v-icon>
          {{ $t('company.consumer.details.export') }}
        </v-btn>
      </v-card-title>
      <v-card-title tile v-if="consumers">
        <v-text-field
          v-model="search"
          color="primary"
          prepend-inner-icon="search"
          :label="$t('screener.search.title')"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>

      <!-- Registrants statistics -->
      <v-card-text v-if="consumers && consumers.total" class="text-xs-center px-0">
        <v-layout row wrap class="grey lighten-4 pa-3">
          <v-flex xs2>
            <div>
              <div class="greyDarken3--text display-2">{{ consumers.total }}</div>
              <div
                class="subheading grey--text text--darken-3 font-weight-thin"
              >{{ $t('screener.admin.total_participants') }}</div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-data-table
        v-if="consumers"
        :headers="table_headers"
        :items="consumers.data"
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :total-items="consumers.total"
        :rowsPerPageItems="[25, 100, 200,{'text':'All','value':0}]"
      >
        <!-- <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['text-xs-left']"
            >{{ header.text }}</th>
          </tr>
        </template>-->

        <template v-slot:items="props">
          <tr :active="props.selected">
            <!-- <td width="2%" class="text-xs-left">
              <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
            </td>-->
            <td width="6%" class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">
              <span v-if="props.item.name">{{ props.item.name }}</span>
              <span v-else>-</span>
            </td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td
              width="15%"
              class="text-xs-left"
            >{{ moment(props.item.created_at).format('DD MMM YYYY, HH:MM') }}</td>
            <td width="15%" class="text-xs-left">
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  :to="{name:'consumer.index',params:{consumer_id: props.item.id}}"
                >
                  <v-icon color="primary">$vuetify.icons.rms_visibility</v-icon>
                </v-btn>
                <span
                  class="greyDarken3--text body-1"
                >{{ $t('company.consumer.details.form.btn.show.details') }}</span>
              </v-tooltip>
              <v-tooltip slot="append" top color="white">
                <v-btn slot="activator" icon small dark @click="showPassword(props.item.id)">
                  <v-icon color="secondary">$vuetify.icons.rms_password</v-icon>
                </v-btn>
                <span class="greyDarken3--text body-1">{{ $t('screener.tooltip.show_password') }}</span>
              </v-tooltip>
              <!-- Delete registrant btn -->
              <!-- <ConfirmationDialog
                :desc="'screener.registrant.remove.confirmation.description'"
                :action="
                  getDialogAction(
                    props.item.id,
                    'rms_delete',
                    'error',
                    'delete',
                  )
                "
                :headline="'screener.registrant.remove.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>-->
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">{{ $t('rms.alert.search_not_found') }}</v-alert>
        </template>
      </v-data-table>
      <v-layout v-else row wrap justify-center align-center>
        <v-flex xs12>
          <v-layout column justify-center align-center>
            <v-img src="../../assets/no-data.svg" width="40%" height="100%"></v-img>
            <div class="mt-5 my-3">
              <div class="headline grey--text text--darken-2">
                {{ $t('assets_manager.empty_assets.message_1',{
                entity : 'participants'
                })}}
              </div>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
    <v-dialog v-model="showPasswordDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ $t('screener.consumer.password.title') }}</v-card-title>
        <v-card-text v-if="consumerPassword" class="text-xs-center">
          <div class="headline">{{ consumerPassword }}</div>
        </v-card-text>
        <v-card-text v-else>{{ $t('screener.save.password_not_generated') }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="lightteal"
            dark
            outline
            @click="
              $copyText(consumerPassword);
              showPasswordDialog = false;
              consumerPassword = null;
            "
          >{{ $t('screener.btn.copy') }}</v-btn>
          <v-btn
            color="lightteal"
            dark
            outline
            @click="
              showPasswordDialog = false;
              consumerPassword = null;
            "
          >{{ $t('screener.btn.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Refund
      v-if="isScreeningPaid(screener)"
      :screener="screener"
      :dialog="show_refund_confirmation"
      @onCancel="resetRefund"
      @onRefund="refund"
    >
      <div slot="note" class="greyDarken1--text">
        <i>{{$t('screener.refund.warning')}}</i>
      </div>
    </Refund>
  </v-card>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";
import i18n from "@/i18n";
import { getCurrencySymbol } from "@/helper";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "@/validation";
import Refund from "@/components/screener/monetization/Refund";

export default {
  data() {
    return {
      rules,
      createDialog: false,
      consumer_email: null,
      search: "",
      confirmation: false,
      deleteAllConfirmation: false,
      showPasswordDialog: false,
      loading: false,
      table_headers: [
        { text: "SN", align: "left", sortable: false },
        {
          text: "Name",
          sortable: true,
          align: "left",
          value: "name"
        },
        {
          text: "Email",
          sortable: false,
          align: "left",
          value: "email"
        },
        {
          text: "Created At",
          align: "left",
          sortable: false,
          value: "created_at"
        },
        {
          text: "Action",
          align: "left",
          value: "delete",
          sortable: false
        }
      ],
      consumer_id: null,
      pagination: {
        sortBy: "created_at",
        descending: true,
        rowsPerPage: 25,
        page: 1
      },
      selected: [],
      consumerPassword: null,
      screening_attended_count: null,
      total_purchased_count: null,
      total_enrolled_count: null,
      show_refund_confirmation: false
    };
  },
  components: { ConfirmationDialog, Refund },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    search: {
      handler() {
        this.getDataFromApi();
      }
    }
  },
  created() {
    // if (this.$route.params.screener_id != undefined) {
    //   this.getDataFromApi();
    // }
  },
  computed: {
    ...mapGetters({
      isSuperAdmin: "user/isSuperAdmin"
    }),
    ...mapGetters("screener", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      consumers: "list"
    }),
    screener() {
      //FIXME::Temporary fix for live counter
      return this.$store.getters["screener/getScreener"](
        this.$route.params.screener_id
      );
    }
  },
  methods: {
    async remove(consumer_id) {
      try {
        var result = await this.$store.dispatch("consumer/detachConsumer", {
          consumer_id: consumer_id,
          screener_id: this.$route.params.screener_id
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrant removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      } finally {
        this.confirmation = false;
      }
    },
    async deleteAll() {
      try {
        var result = await this.$store.dispatch("consumer/detachAllConsumer", {
          screener_id: this.$route.params.screener_id
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrants removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      } finally {
        this.confirmation = false;
      }
    },

    async getDataFromApi() {
      try {
        this.loading = true;
        var result = await this.$store.dispatch("consumer/getAllConsumerList", {
          screener_id: this.$route.params.screener_id,
          row_per_page: this.pagination.rowsPerPage,
          page: this.pagination.page,
          search: this.search
        });
        // this.consumers = result.consumers;
        this.loading = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    async showPassword(consumer_id) {
      try {
        this.consumerPassword = null;
        var result = await this.$store.dispatch("consumer/showPassword", {
          id: consumer_id
        });

        this.consumerPassword = result.password;
        this.showPasswordDialog = true;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    async sendVerificationsEmails() {
      // try {
      //   var result = await this.$store.dispatch(
      //     "customer/sendVerificationsEmails",
      //     {
      //       customers: this.getSelectedConsumerIds(this.selected),
      //       screener_id: this.$route.params.screener_id
      //     }
      //   );
      //   this.$store.dispatch("app/showMessage", {
      //     message: i18n.t(
      //       "screener.customers.send.verification.success.message"
      //     ),
      //     color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
      //   });
      // } catch (error) {
      //   this.$store.dispatch("app/showMessage", {
      //     message: error.message,
      //     color: this.DEFINES.SNACKBAR_ERROR_COLOR
      //   });
      // }
    },

    async sendReminders() {
      try {
        var result = await this.$store.dispatch("consumer/sendReminders", {
          consumers: this.getSelectedConsumerIds(this.selected),
          screener_id: this.$route.params.screener_id
        });
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("screener.consumers.send.reminder.success.message"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    async create() {
      try {
        if (!this.$refs.consumerForm.validate()) {
          return false;
        }
        var result = await this.$store.dispatch("consumer/createByAdmin", {
          screener_id: this.$route.params.screener_id,
          email: this.consumer_email
        });
        this.getDataFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      } finally {
        this.createDialog = false;
      }
    },

    async download() {
      try {
        var result = await this.$store.dispatch(
          "screener/downloadAllConsumers",
          {
            screener_id: this.$route.params.screener_id
          }
        );
        window.open(result.link, "_blank");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.consumers.data.slice();
    },
    getSelectedConsumerIds(selected_consumers) {
      return selected_consumers.map(consumer => consumer.id);
    },

    openCreateDialog() {
      this.createDialog = true;
      this.consumer_email = null;
    },

    getDialogAction(
      consumer_id = null,
      btn_icon,
      btn_color,
      btn_lable,
      action
    ) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        button_label: btn_lable,
        no_outline: true,
        method: action == "deleteAll" ? this.deleteAll : this.remove,
        payload: consumer_id
      };
    },

    onBeforeRefund(consumer_id) {
      this.consumer_id = consumer_id;
      this.show_refund_confirmation = true;
    },

    resetRefund() {
      this.consumer_id = null;
      this.show_refund_confirmation = false;
    },
    async refund() {
      try {
        await this.$store.dispatch("consumer/refund", {
          screener_id: this.screener.id,
          consumer_id: this.consumer_id
        });
        await this.$store.dispatch("app/showMessage", {
          message: i18n.t("screener.refund.success"),
          color: "success"
        });
        this.resetRefund();
        /* Get updated list */
        this.getDataFromApi();
      } catch (error) {
        this.resetRefund();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    async exportAllConsumersReport() {
      this.$store
        .dispatch("consumer/exportAllConsumersReport")
        .then(response => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.consumer.report_email.msg"),
            color: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    }
  }
};
</script>
